"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketoSendStatus = void 0;
var MarketoSendStatus;
(function (MarketoSendStatus) {
    MarketoSendStatus["NONE"] = "None";
    MarketoSendStatus["SENT_SUCCESSFULLY"] = "SentSuccessfully";
    MarketoSendStatus["USER_REFUSED_TO_SEND"] = "UserRefusedToSend";
    MarketoSendStatus["SEND_FAILED"] = "SendFailed";
})(MarketoSendStatus || (exports.MarketoSendStatus = MarketoSendStatus = {}));
